import React, { useEffect, useState } from 'react';
import './FadeInTrigg.css';


function FadeInTrigg( { children, toggle, side } ){

  const [active, setActive] = useState(false);

  useEffect( () => {
    setActive(toggle);
  }, [toggle]);

  return(
    <div id='' className={`trigg-fade-in ${ side } ${ active ? 'active' : '' }`}>
      { children }
    </div>
  );

}

export default FadeInTrigg;